<!-- Select principal via generic-form-gen (mantém o padrão visual label + dots do sistema) -->
<cpi-generic-form-gen [columns]="1" [labels]="labels" [setGenericForm]="[field]" [boldLabel]="false"> </cpi-generic-form-gen>

<!-- Sub-campos: exibidos após seleção, somente leitura -->
<div class="json-dynamic-subfields" *ngIf="selectedData">
	<div class="json-dynamic-subfield" *ngFor="let key of getSubFieldKeys()">
		<div class="json-dynamic-sublabel">{{ key }}</div>
		<span class="json-dynamic-dots"></span>
		<input class="json-dynamic-subinput" type="text" [value]="selectedData[key] ?? ''" disabled readonly />
	</div>
	<div class="json-dynamic-information" *ngIf="getInformationText()">
		<span class="json-dynamic-information-icon">ℹ</span>
		<span class="json-dynamic-information-text">
			<ng-container *ngFor="let seg of getInformationSegments()">
				<a
					*ngIf="seg.type === 'link'"
					[href]="seg.value"
					target="_blank"
					rel="noopener noreferrer"
					class="json-dynamic-information-link"
					>{{ seg.value }}</a
				>
				<span *ngIf="seg.type === 'text'">{{ seg.value }}</span>
				<span *ngIf="seg.type === 'break'" class="json-dynamic-information-break"></span>
			</ng-container>
		</span>
	</div>
</div>
